import React from 'react';
export function CheckboxDashIcon(props) {
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", width: "16", height: "16", fill: "currentColor" }, props),
        React.createElement("path", { d: "M4 7h9v3H4z" })));
}
